import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import HistorySearchForm from './components/HistorySearchForm';
import HistoryTable from './components/HistoryTable';
import { AppDispatch } from '../../stores/store';
import { useDispatch } from 'react-redux';
import { getHistory, resetHistoryData } from '../../stores/history/slice';
import { HistorySearchParam } from '../../stores/history/api';
import { isRejected } from '@reduxjs/toolkit';
import { isGetOperationHistoryList } from '../../_utils/typeGuardUtils';
import useErrorModal from '../../hooks/useErrorModal';
import ErrorModal from '../../_common/Modal/ErrorModal';
import { ROWS_PER_PAGE_LIST } from '../../_constants/Const';
import { API_CODE } from '../../_constants/apiConst';

const defaultParams = {
  rmaNo: '',
  serialNo: '',
  from: '',
  to: '',
  rowFrom: 0,
  perPage: ROWS_PER_PAGE_LIST[0],
};

const ManageHistory: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { error, showApiError, showTypeError, hideError } = useErrorModal();
  const [params, setParams] = useState<HistorySearchParam>(defaultParams);
  const [page, setPage] = useState<number>(0);

  // マウント時にデータを初期化
  useEffect(() => {
    dispatch(resetHistoryData());
  }, [dispatch]);

  /** クリアボタン押下 */
  const handleClear = () => {
    // 検索パラメータのみクリア
    const { rowFrom, perPage } = params;
    setParams({ ...defaultParams, rowFrom, perPage });
  };

  /** 検索ボタン押下 */
  const onClickSearch = () => {
    handleSearch(undefined);
    setPage(0);
  };

  /** 検索 */
  const handleSearch = async (requestParams?: HistorySearchParam) => {
    const response = await dispatch(getHistory(requestParams ?? params));
    if (isRejected(response)) {
      showApiError(response.payload, API_CODE.OPERATION_HISTORY);
      return;
    }
    if (!isGetOperationHistoryList(response.payload)) {
      showTypeError(API_CODE.OPERATION_HISTORY);
    }
  };

  return (
    <Box mt={8}>
      <HistorySearchForm
        params={params}
        updateParams={setParams}
        handleClear={handleClear}
        onClickSearch={onClickSearch}
      />
      <HistoryTable
        params={params}
        updateParams={setParams}
        page={page}
        updatePage={setPage}
        handleSearch={handleSearch}
      />
      {error && <ErrorModal message={error} onClose={hideError} />}
    </Box>
  );
};

export default ManageHistory;
